import { render, staticRenderFns } from "./RevealedCard.vue?vue&type=template&id=06914f8f&scoped=true&"
import script from "./RevealedCard.vue?vue&type=script&lang=js&"
export * from "./RevealedCard.vue?vue&type=script&lang=js&"
import style0 from "./RevealedCard.vue?vue&type=style&index=0&id=06914f8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06914f8f",
  null
  
)

export default component.exports